document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".tech-info__tab");
  const tabContents = document.querySelectorAll(".tech-info__tab-content");

  function hideAllTabContents() {
    tabContents.forEach(content => content.classList.add("hidden"));
  }

  function removeActiveClassFromTabs() {
    tabs.forEach(tab => tab.classList.remove("active"));
  }

  function showTabContent(index) {
    tabContents[index].classList.remove("hidden");
  }

  function addActiveClassToTab(index) {
    tabs[index].classList.add("active");
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      hideAllTabContents();
      removeActiveClassFromTabs();
      showTabContent(index);
      addActiveClassToTab(index);
    });
  });

  // Initial setup
  hideAllTabContents();
  removeActiveClassFromTabs();
  showTabContent(0);
  addActiveClassToTab(0);
});
